import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';

var MetricsCollector = function () {
  function MetricsCollector(storage) {
    _classCallCheck(this, MetricsCollector);

    this.storage = storage;

    this.latency = this.latency.bind(this);
    this.count = this.count.bind(this);
    this.countException = this.countException.bind(this);
  }

  _createClass(MetricsCollector, [{
    key: 'latency',
    value: function latency(ms) {
      this.storage.metrics.track(this.metricType + '.time', ms);
    }
  }, {
    key: 'count',
    value: function count(status) {
      this.storage.count.track(this.metricType + '.status.' + status);
    }
  }, {
    key: 'countException',
    value: function countException() {
      this.storage.count.track(this.metricType + '.exception');
    }
  }]);

  return MetricsCollector;
}();

export var SegmentChangesCollector = function (_MetricsCollector) {
  _inherits(SegmentChangesCollector, _MetricsCollector);

  function SegmentChangesCollector(storage) {
    _classCallCheck(this, SegmentChangesCollector);

    var _this = _possibleConstructorReturn(this, (SegmentChangesCollector.__proto__ || _Object$getPrototypeOf(SegmentChangesCollector)).call(this, storage));

    _this.metricType = 'segmentChangeFetcher';
    return _this;
  }

  return SegmentChangesCollector;
}(MetricsCollector);

export var SplitChangesCollector = function (_MetricsCollector2) {
  _inherits(SplitChangesCollector, _MetricsCollector2);

  function SplitChangesCollector(storage) {
    _classCallCheck(this, SplitChangesCollector);

    var _this2 = _possibleConstructorReturn(this, (SplitChangesCollector.__proto__ || _Object$getPrototypeOf(SplitChangesCollector)).call(this, storage));

    _this2.metricType = 'splitChangeFetcher';
    return _this2;
  }

  return SplitChangesCollector;
}(MetricsCollector);

export var MySegmentsCollector = function (_MetricsCollector3) {
  _inherits(MySegmentsCollector, _MetricsCollector3);

  function MySegmentsCollector(storage) {
    _classCallCheck(this, MySegmentsCollector);

    var _this3 = _possibleConstructorReturn(this, (MySegmentsCollector.__proto__ || _Object$getPrototypeOf(MySegmentsCollector)).call(this, storage));

    _this3.metricType = 'mySegmentsFetcher';
    return _this3;
  }

  return MySegmentsCollector;
}(MetricsCollector);

export var SDKCollector = function () {
  function SDKCollector(storage) {
    _classCallCheck(this, SDKCollector);

    this.storage = storage;

    this.ready = this.ready.bind(this);
    this.latency = this.latency.bind(this);
  }

  _createClass(SDKCollector, [{
    key: 'ready',
    value: function ready(ms) {
      this.storage.metrics.track('sdk.ready', ms);
    }
  }, {
    key: 'latency',
    value: function latency(ms) {
      this.storage.metrics.track('sdk.getTreatment', ms);
    }
  }]);

  return SDKCollector;
}();


//////////////////
// WEBPACK FOOTER
// ./node_modules/@splitsoftware/splitio/es/metrics/Collectors.js
// module id = pE1m
// module chunks = 88